import { useMarketplaceLabel, marketplaceSeriesCodes } from "../logistica/configurazione/marketplaceDisplay";
import React, { useState, useEffect } from 'react';
import ContainerLoaderCharts from '../logistica/Charts/ContainerLoaderCharts';
import stilePulsanti from '../interfaccia/stilePulsanti';
import SettingBooleano from './SettingBooleano';

function StatSpedMarketplaces({
  mobile
}) {
  
    const marketplaceLabel = useMarketplaceLabel();
    const {
        buttonClassesWhite,
        buttonClassesGreen,
        buttonClassesOrange
    } = stilePulsanti

    const colors = {
        amz: "#ff9800",
        ebay: "#009688",
        prestashop: "#1565c0",
        storeVS: "#9c27b0",
        storeJS: "#b71c1c",
        cdiscount: "#e91e63",
        eprice: "#8bc34a",
        colizey: "#00bcd4",
        other: "#9e9e9e"
    };

    const [settings, setSettings] = useState({
        series: {
            amz: true,
            ebay: true,
            prestashop: true,
            storeVS: true,
            storeJS: true,
            cdiscount: true,
            eprice: true,
            colizey: true,
            other: false
        },        
        anni: 3,
        robaDaSommare: "importo",
        stack: 1
    })



  return (
    
        <div className='sfondoBiancoTema tc pa3'>
        <h3>Ordini per marketplaces all-time</h3>
            <div className='flex items-center justify-center'>
                <div>ultimi</div>
            <input
                type='number'
                value={settings.anni}
                onChange={(e)=>setSettings({...settings,anni:e.target.value})}
                className={stilePulsanti.inputClassesRicercaOrizzontale}
                min={1}
                max={10}
            />
            <div className='mr4'>anni</div>
            {Object.keys(settings.series).map((mp)=>{
                const attivo = settings.series[mp];
                const colore = colors[mp] || "#ccc";
                return (
                    <button
                        key={mp === 'other' ? 'Other' : marketplaceLabel(marketplaceSeriesCodes[mp])}
                        onClick={() =>
                            setSettings({
                                ...settings,
                                series: { ...settings.series, [mp]: !attivo },
                            })
                        }
                        className="ma1 pa2 pointer br2 f6 b--none"
                        style={{
                            backgroundColor: attivo ? colore : "#f5f5f5",
                            color: attivo ? "#fff" : "#333",
                            border: attivo ? "none" : "1px solid #ccc",
                            minWidth: "5rem",
                        }}
                    >
                        {mp === 'other' ? 'Other' : marketplaceLabel(marketplaceSeriesCodes[mp])}
                    </button>
                );
            })}
            <div className='ml4 mr3'>importo ordini/numero ordini</div>
            <SettingBooleano 
                value={settings.robaDaSommare}
                    trueButtonClass={buttonClassesOrange}
                    falseButtonClass={buttonClassesGreen}
                    trueElement={"importo"}
                    falseElement={"ordini"}
                    setTrue={()=>setSettings({...settings,robaDaSommare:"importo"})}
                    setFalse={()=>setSettings({...settings,robaDaSommare:"ordini"})}
                    customValueTrue={"importo"}
                    customValueFalse={"ordini"}
            />
            <div className='ml4 mr3'>stack / linee</div>
            <SettingBooleano 
                value={settings.stack}
                    trueButtonClass={buttonClassesOrange}
                    falseButtonClass={buttonClassesGreen}
                    trueElement={"stack"}
                    falseElement={"linee"}
                    setTrue={()=>setSettings({...settings,stack:1})}
                    setFalse={()=>setSettings({...settings,stack:0})}
            />
            </div>          
            <ContainerLoaderCharts 
                query={`/contab/charts/linesSpedizioniMarketplaces?`+ new URLSearchParams({anni: settings.anni, robaDaSommare: settings.robaDaSommare})}
                titolo=""
                tipo ="linesSpedizioniMarketplaces"
                displayTitolo={false}
                settings={settings}
            />
        </div>
  )
}

export default StatSpedMarketplaces;
